exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#parceiros[data-v-47816e08]{background-color:#4bb958;padding-top:100px}#parceiros .parceiros-wrap[data-v-47816e08]{position:relative;overflow:hidden;text-align:center}#parceiros .parceiro[data-v-47816e08]{display:inline-block;margin-bottom:30px;margin:20px;background-color:#fff;border-radius:15px}#parceiros .img-content[data-v-47816e08]{width:150px;height:150px;object-fit:contain;overflow:hidden;margin:20px 30px;display:inline-block}#parceiros .img-content a[data-v-47816e08]{display:block}#parceiros .img-content img[data-v-47816e08]{width:100%;display:inline-block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-47816e08","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./_source/javascript/components/parceiros.vue
// module id = 229
// module chunks = 0